// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"72":"9b5a623c","308":"27928d16","325":"35e17a3d","807":"683baf32"}[chunkId] + ".chunk.css";
};